import Immutable from 'immutable';
import { RawSubmittal, Submittal } from 'records/Submittal';

export interface RawReviewSubmittal {
  type: string;
  submittal: RawSubmittal;
}

export interface ReviewSubmittalData {
  type: string;
  submittal: Submittal;
  files: Immutable.List<File>;
}

const defaultValues: ReviewSubmittalData = {
  type: 'ReviewSubmittal',
  submittal: new Submittal(),
  files: Immutable.List<File>(),
};

export const ReviewSubmittalFactory = Immutable.Record(
  defaultValues,
  'ReviewSubmittal'
);

export class ReviewSubmittal extends ReviewSubmittalFactory {
  serialize(): RawReviewSubmittal {
    return this.toJS();
  }

  static deserialize(rawReviewSubmittal: RawReviewSubmittal): ReviewSubmittal {
    return new ReviewSubmittal({
      ...rawReviewSubmittal,
      submittal: Submittal.deserialize(rawReviewSubmittal.submittal),
    });
  }
}
